module.exports = __webpack_public_path__ + "img/album12_10.152c9abc.jpg";